const Notification = {
  icons: {
    success: "success",
    error: "error",
    info: "info",
    warning: "warning",
  },

  toastIcons: {
    success: '<path d="M5 12l5 5l10 -10" />',
    error: '<path d="M18 6l-12 12" /><path d="M6 6l12 12" />',
    info: '<path d="M12 8h.01" /><path d="M11 12h1v4h1" />',
    warning: '<path d="M12 8v4" /><path d="M12 16h.01" />',
  },

  toastIconHtml(iconType) {
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${this.toastIcons[iconType]}</svg>`;
  },

  titles: {
    success: window.translations?.success || "Success",
    error: window.translations?.error || "Error",
    info: window.translations?.info || "Info",
    warning: window.translations?.warning || "Warning",
  },

  show: function (message, type = "info", duration = 10000) {
    if (typeof Swal === "undefined") {
      console.error("SweetAlert2 is not loaded");
      alert(message);
      return;
    }

    const iconType = this.icons[type] || this.icons.info;
    const title = this.titles[type] || this.titles.info;

    const swalConfig = {
      icon: iconType,
      title: "",
      text: message,
      confirmButtonText: window.translations?.close || "Close",
      timer: duration > 0 ? duration : undefined,
      timerProgressBar: false,
      showConfirmButton: true,
      customClass: {
        popup: "notification-popup",
        confirmButton: "notification-button",
      },
    };

    return Swal.fire(swalConfig);
  },

  close: function () {
    if (typeof Swal !== "undefined") {
      Swal.close();
    }
  },

  toast(message, type = "success", duration = 3000, position = "top-end") {
    if (typeof Swal === "undefined") {
      console.error("SweetAlert2 is not loaded");
      return;
    }

    const iconType = this.icons[type] || this.icons.info;

    return Swal.fire({
      toast: true,
      position: position,
      icon: iconType,
      iconHtml: this.toastIconHtml(iconType),
      title: message,
      showConfirmButton: false,
      timer: duration,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
      },
      customClass: {
        popup: `notification-toast notification-toast--${iconType}`,
      },
    });
  },
};

window.showNotification = function (message, type = "info", duration = 5000) {
  return Notification.show(message, type, duration);
};

window.showToast = function (message, type = "success", duration = 5000) {
  Notification.toast(message, type, duration, "bottom-end");
};
